import { Navigate } from 'react-router-dom';
import i18next from 'i18next';
import FuseLoading from '@fuse/core/FuseLoading';

import settingsConfig from 'app/fuse-configs/settingsConfig';
import modulesConfigs from 'app/main/modules/modulesConfigs';
import submodulesConfigs from 'app/main/submodules/submodulesConfigs';
import pagesConfigs from 'app/main/pages/pagesConfigs';

import en from 'app/main/i18n/en';
import it from 'app/main/i18n/it';
import test from 'app/main/i18n/test';
import NavigationUtils, { type AppRoute } from 'app/store/components/NavigationUtils';

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);
i18next.addResourceBundle('test', 'core', test);

const routeConfigs = [...pagesConfigs, ...modulesConfigs, ...submodulesConfigs];

const routes: AppRoute[] = [
	...NavigationUtils.generateRoutesFromConfigs(routeConfigs, settingsConfig.defaultAuth),
	{
		path: '/',
		element: <Navigate to={settingsConfig.loginRedirectUrl} replace />
	},
	{
		path: 'loading',
		element: <FuseLoading />
	},
	{
		path: '*',
		element: <Navigate to="/404" replace />
	}
];

export default routes;
